import {WithSummaryModel} from '../../../../../common/entity/dto/plain/withSummary.model';
import {SaleRetrocessionSummaryModel} from './saleRetrocessionSummary.model';
import {SaleProductSummaryModel} from '../../../product/api/entity/saleProductSummary.model';
import {UserSummary} from "../../../../../account/modules/user/api/entity/userSummary.model";

export class SaleRetrocessionModel extends WithSummaryModel<SaleRetrocessionSummaryModel> {
    saleProduct: SaleProductSummaryModel;
    saleResponsibleUser: UserSummary;
}
